import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../Redux/hooks";
import { resetState } from "../../Redux/actions/resetAction";
import { Avatar, Box, Menu, MenuItem, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import http from "../../utils/http";
import { AxiosResponse } from "axios";
import { toastMessage } from "../../utils/toast";

const LogoutContainer = () => {
  const dispatch = useAppDispatch();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const role = useAppSelector((state) => state.user.role);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const firstName = localStorage.getItem("first-name");
  const lastName = localStorage.getItem("last-name");
  const [userName] = useState(
    `${firstName ? firstName : ""} ${lastName ? lastName : ""}`
  );
  const logout = async () => {
    try {
      let url = "";
      if (role === "participant") {
        url = "/participant/auth/logout";
      } else {
        url = "/user/auth/logout";
      }
      let res: AxiosResponse;
      res = await http.post(url);
      toastMessage("success", res?.data?.message);
    } catch (err) {
      console.log(err);
    } finally {
      localStorage.clear();
      dispatch(resetState());
      if (role === "participant") {
        navigate("/auth/participant/login");
      } else {
        navigate("/auth/login");
      }
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          cursor: "pointer",
        }}
        onClick={handleClick}
      >
        <Typography variant="body1" color="text.secondary" fontWeight="regular">
          {userName}
        </Typography>
        <Avatar
          sx={{
            width: 40,
            height: 40,
            bgcolor: "lightgray",
            color: "#000",
            fontSize: 16,
          }}
        />
      </Box>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {role !== "participant" && (
          <MenuItem onClick={() => navigate("/profile/change-password")}>
            Change Password
          </MenuItem>
        )}
        <MenuItem onClick={logout}>Logout</MenuItem>
      </Menu>
    </>
  );
};

export default LogoutContainer;
